/* eslint-disable style/no-tabs */
import { useTranslation } from "react-i18next";

function SecurityFailedNoRetries() {
  const { t } = useTranslation("security");

  return (
    <>
      <p>
        {t("security:kyc-failed-no-retries-intro-pt1")}
        {/* We regret to inform you that your final submission attempt for the
				verification process has been unsuccessful. Despite your efforts, our
				system was unable to verify your identity based on the information and
				documents provided. */}
      </p>
      <div class="w-full h-4" />
      <p>
        {t("security:kyc-failed-no-retries-intro-pt2")}
        {/* This marks your final attempt at completing the verification process
				independently. If you believe that you have been wrongfully denied
				verification or have encountered issues beyond your control, we
				encourage you to contact our support team for further assistance. */}
      </p>
      <div class="w-full h-4" />
      <p>
        {t("security:kyc-failed-no-retries-header")}
        {/* To address this matter and request additional assistance, please follow
				these steps: */}
      </p>
      <div class="w-full h-4" />
      <ul>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-no-retries-list-header-1")}
            {" "}
            {/* Contact Customer Support: */}
          </strong>
          {t("security:kyc-failed-no-retries-list-item-1-pt1")}
          {/* Reach out to
					our dedicated artist support team immediately via */}
          <a
            rel="noreferrer"
            href="https://share.hsforms.com/18sIUCWsFTNimqrJIpUUhSw8mkg1"
            target="_blank"
            title="Support Form on hsforms.com"
          >
            {t("security:kyc-failed-no-retries-list-item-1-pt2")}
            {/* this form. */}
          </a>
          <div class="w-full h-4" />
          {t("security:kyc-failed-no-retries-list-item-1-pt3")}
          {/* Explain the situation and the reasons you believe your verification
					was wrongfully denied. */}
        </li>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-no-retries-list-header-2")}
            {" "}
            {/* Provide Relevant Information: */}
          </strong>
          {t("security:kyc-failed-no-retries-list-item-2")}
          {/* When contacting support, be prepared to provide details about your previous verification attempts, any issues encountered, and any additional information that may help us understand your situation better. */}
        </li>
      </ul>
      <div class="w-full h-4" />
      <p>
        {t("security:kyc-failed-no-retries-ending")}
        {/* Our support team is committed to assisting you and will carefully review
				your case to determine if there were any errors or misunderstandings
				during the previous verification attempts. */}
      </p>
    </>
  );
}

export default SecurityFailedNoRetries;
